module.exports = __webpack_public_path__ + "img/australia-infectious-diseases-female.eb891b7b.png";